import React, { useEffect, useState } from "react";
import "./appointment.css";
import Afterloginheader from "../../components/MainHeader/Afterloginheader";
import { toast } from "react-toastify";
import { deleteNotificationApi, fetchNotificationApi } from "../../services/apiService";
import LoadingPage from "../../components/LoadingPage";
import Notification from "../../assets/images/notification.svg";

const NotificationList = () => {
  const [screenLoading, setScreenLoading] = useState(false);
  const [notificationList, setNotificationList] = useState();

  const getNotificationList = async () => {
    try {
      setScreenLoading(true);
      let response = await fetchNotificationApi();
      if (response) {
        if (response.data.res === true) {
          setNotificationList(response.data.data);
        } else {
          // toast.error(response.data.msg, {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      // toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    } finally {
      setScreenLoading(false);
    }
  };
  const handleDeleteNotififation = async (id, value) => {
    try {
      setScreenLoading(true);
      let fd = new FormData();
      fd.append("id", id);
      fd.append("confirm", value);
      let response = await deleteNotificationApi(fd);
      if (response) {
        if (response.data.res === true) {
          getNotificationList();
        } else {
          toast.error(response.data.msg || "Something went wrong in server. Please try again.", { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
    } finally {
      setScreenLoading(false);
    }
  };

  useEffect(() => {
    getNotificationList();
  }, []);

  return (
    <div className="Main">
      <Afterloginheader />
      <div className="AppointmentBody">
        <div className="CustomContainer">
          <div className="AppointmentTopBox">
            <h3>Notifications</h3>
          </div>
        </div>
        {screenLoading ? (
          <div data-testid="loading-page">
            <LoadingPage />
          </div>
        ) : null}
        <div className="notificationMain">
          {notificationList && notificationList.length > 0 ? (
            <>
              {notificationList.map((item, index) => (
                <div className="notiWrapper" key={index}>
                  <div className="NotificationLeft">
                    <div className="imgWrapper">
                      <img src={Notification} className="notiIcon" alt="icon" />
                    </div>
                    <div className="middleSec">
                      <h4 className="notiText">{item?.message}</h4>
                    </div>
                  </div>
                  <div className="btnWrapper">
                    {/* {item?.types === "Appointment" ? (
                      <>
                        <button className="confirmBtn" onClick={() => handleAction(item?.id, "1")}>
                          Confirm
                        </button>
                        <button className="cancelBtn" onClick={() => handleAction(item?.id, "0")}>
                          Cancel
                        </button>
                      </>
                    ) : (
                      <button className="cancelBtn" onClick={() => handleAction(item?.id, "1")}>
                        Cancel
                      </button>
                    )} */}
                    <button className="cancelBtn" onClick={() => handleDeleteNotififation(item?.id, "1")}>
                      Cancel
                    </button>
                  </div>
                </div>
              ))}
            </>
          ) : !screenLoading ? (
            <>
              <div className="noDocFound" data-testid="no-notifications-found">
                No Notifications found!
              </div>{" "}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default NotificationList;
